export const contacts = {
    email: 'info@dmfplumbingandheating.com',
    mobile: '+447794156943',
    phone: '07 794 156 943',
    twitter: 'http://twitter.com',
    facebook: 'https://www.facebook.com/profile.php?id=61573170112334',
    maps: 'https://www.google.com/maps/place/5+Hammer+Ln,+Haslemere+GU27+3QD/@51.082989,-0.754629,17z/data=!3m1!4b1!4m6!3m5!1s0x487434ae1e1f47ed:0x2bdcb436094b60eb!8m2!3d51.082989!4d-0.7520541!16s%2Fg%2F11kpl9ddxt?entry=ttu',
    address: {
        street: '5 Hammer Lane',
        town: 'Haslemere',
        county: 'West Sussex',
        postcode: 'GU27 3QD',
    },
    company: {
        name: 'DMF Plumbing and Heating LTD',
        registeredBusinessAddress: '26 High Street, Haslemere, Surrey, GU27 2HW',
        tradingName: 'DMF Plumbing & Heating',
        tradingAddress: '5 Hammer Lane, Haslemere, West Sussex,  GU27 3QD',
        director: 'Daniel Fitzgerald',
        vatNumber: '271851494',
        companyNumber: '07951171',
    }
};